export default function UkrailResultsController(
    $scope,
    $controller,
    $stateParams,
    flightsFactory,
    $state,
    userService
) {
    'ngInject';

    $controller('UkrailResultsBaseController', {
        $scope,
        cfg: {
            resultsRoute: 'main.ukrail',
        },
        flightsFactory,
        $state,
        $stateParams: {
            IsRailSearchAvailable: $scope.IsRailSearchAvailable,
            RailSearchId: $scope.RailSearchId,
        },
    });

    init();

    function init() {
        const {currencySign} = userService.getRegionalSettings();
        const {RailMinTotal} = flightsFactory.getFlights();
        Object.assign($scope, {
            currencySign,
            railMinTotal: RailMinTotal,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/controllers/ukrailResultsCtrl.js